import { FC, useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { getUserProfile } from 'features/user/actions';
import { getBuyersCounteroffers } from 'features/secondaryMarket/actions';

import { SecondaryMarketOffers } from './SecondaryMarketOffers';
import { AgreeWithTerms } from 'componets/ui';
import { ReceivedCounteroffers } from './ReceivedCounteroffers';
import { SentCounteroffers } from './SentCounteroffers';

import { selectUser } from 'selectors';

export const SecondaryMarket: FC = () => {
	const dispatch = useAppDispatch();

	const [type, setType] = useState('offers');

	const user = useAppSelector(selectUser);
	const buyerCounteroffersCount = useAppSelector(
		(state) => state.secondaryMarket.buyerCounterofferPager.totalCount,
	);

	const counteroffersCount = user?.secondaryMarket?.counterOffers?.count;

	const t = useTranslate([
		'secondaryMarketText',
		'receivedCounteroffersText',
		'sentCounteroffersText',
	]);

	useEffect(() => {
		dispatch(getUserProfile());
		dispatch(getBuyersCounteroffers());
	}, [dispatch]);

	const isTabs = counteroffersCount > 0 || buyerCounteroffersCount > 0;

	useEffect(() => {
		if (counteroffersCount === 0 && type !== 'offers') {
			setType('offers');
		}
	}, [counteroffersCount]);

	return (
		<>
			<div>
				{isTabs ? (
					<Tabs
						className="accountTabs"
						type="card"
						defaultActiveKey={type}
						activeKey={type}
						onChange={(v: string) => setType(v)}
						destroyInactiveTabPane
					>
						<Tabs.TabPane tab={t.secondaryMarketText} key="offers">
							<SecondaryMarketOffers />
						</Tabs.TabPane>

						{counteroffersCount > 0 && (
							<Tabs.TabPane
								tab={
									<span>
										{t.receivedCounteroffersText}
										<Typography.Text type="danger">&nbsp;({counteroffersCount})</Typography.Text>
									</span>
								}
								key="receivedCounteoffers"
							>
								<ReceivedCounteroffers />
							</Tabs.TabPane>
						)}

						{buyerCounteroffersCount > 0 && (
							<Tabs.TabPane tab={t.sentCounteroffersText} key="sentCounteroffers">
								<SentCounteroffers />
							</Tabs.TabPane>
						)}
					</Tabs>
				) : (
					<SecondaryMarketOffers />
				)}
			</div>

			{!user.agreeWithTerms && <AgreeWithTerms />}
		</>
	);
};
